export default __webpack_public_path__ + "static/media/ht.bde97d77.svg";